import { PLAY_FULL_MEDIA, IS_ENDING, RESIZE_FULL_MEDIA, REPLACE_FULL_SOURCE_MEDIA } from '../actions/playmedia';

const initialState = {
  // Define this player as full, when we do the first load of the app
  isPip: false,
  isEnding: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case PLAY_FULL_MEDIA:

      return action.pgm;
      //return { ...state, ...action.pgm };
    case RESIZE_FULL_MEDIA:
      return { ...state, size: action.size, isEnding: false };

    case REPLACE_FULL_SOURCE_MEDIA:
      return { ...state, newSource: action.newSource, isEnding: false };

    case IS_ENDING:
      return { ...state, isEnding: action.isEnding };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/player.js